import XIcon from '@/shared-components/icons/components/public/XIcon';
import GenericPopup from '@/shared-components/popups/components/GenericPopup';
import Text from '@/shared-components/text/components/Text';

import './AudienceSelectionPopup.css';

export default function AudienceSelectionPopup({ open, onClose, onSelect }) {
  const handleSelect = audience => {
    onClose();
    onSelect(audience);
  };

  return (
    <GenericPopup
      open={open}
      className="content-audience-popup remove-scrollbar"
      opacity
      onBackgroundClick={onClose}
    >
      <div className="generic-popup__header content-audience-popup__header">
        <Text className="generic-popup__header-text-theme">
          Publication audience
        </Text>
        <XIcon className="generic-popup__close" onClick={onClose} />
      </div>

      <Text className="content-audience-popup__description">
        Who can view this publication?
      </Text>

      <div className="content-audience-popup__actions">
        <button
          type="button"
          className="content-audience-popup__option"
          onClick={() => handleSelect('vip_only')}
        >
          Members only
        </button>
        <button
          type="button"
          className="content-audience-popup__option content-audience-popup__option--primary"
          onClick={() => handleSelect('public')}
        >
          Public
        </button>
      </div>
    </GenericPopup>
  );
}
